import { useState, useEffect, useCallback } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Hook for Google Play Age Signals API (Texas SB 2420 compliance)
 * Only works on Android devices with Google Play Services
 */
export function useAgeSignals() {
  const [ageSignals, setAgeSignals] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const checkAgeSignals = useCallback(async () => {
    // Only available on Android
    if (Capacitor.getPlatform() !== 'android') {
      setAgeSignals({
        isAdult: true,
        shouldRestrict: false,
        userStatus: 'NOT_ANDROID',
        platform: Capacitor.getPlatform()
      });
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const AgeSignals = Capacitor.Plugins.AgeSignals;
      
      if (!AgeSignals) {
        console.warn('AgeSignals plugin not available');
        setAgeSignals({
          isAdult: true,
          shouldRestrict: false,
          userStatus: 'PLUGIN_NOT_AVAILABLE'
        });
        return;
      }

      const result = await AgeSignals.checkAgeSignals();
      console.log('Age Signals Result:', result);
      setAgeSignals(result);
      
    } catch (err) {
      console.error('Age Signals Error:', err);
      setError(err.message || 'Failed to check age signals');
      // Default to adult on error (API only returns data in applicable regions)
      setAgeSignals({
        isAdult: true,
        shouldRestrict: false,
        userStatus: 'ERROR',
        error: err.message
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    ageSignals,
    loading,
    error,
    checkAgeSignals,
    // Convenience getters
    isAdult: ageSignals?.isAdult ?? true,
    shouldRestrict: ageSignals?.shouldRestrict ?? false,
    minAge: ageSignals?.minAge,
    maxAge: ageSignals?.maxAge,
    userStatus: ageSignals?.userStatus
  };
}

export default useAgeSignals;
